import { LocalStorageKeys } from '@authentication/constants';

import axiosClient from '@services/axiosClient';
import axios, { AxiosResponse } from 'axios';

import { Navigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import LoginResponse from '@authentication/models/login.response.dto';
import { destroyUserCache, getItem } from '@/lib/storageUtil';
import EndPoints from '@services/endpoints';
import LoginRequest from '@authentication/models/login.request.dto';
import ForgotPasswordRequestDto from '@authentication/models/forgot-password.request.dto';
import ResetPasswordRequestDto from '@authentication/models/reset-password.request.dto';

export const login = (
  data: LoginRequest,
): Promise<AxiosResponse<LoginResponse>> => {
  return axiosClient.post(EndPoints.auth.admin, data);
};

export const forgotPassword = ({
  username,
}: ForgotPasswordRequestDto): Promise<AxiosResponse<null>> => {
  return axiosClient.get(EndPoints.user.forgotPassword(username));
};

export const resetPassword = ({
  data,
  token,
}: {
  data: ResetPasswordRequestDto;
  token: string;
}): Promise<AxiosResponse<null>> => {
  return axios.put(EndPoints.user.resetPassword(token), data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
const refreshToken = getItem(LocalStorageKeys.REFRESH_TOKEN);

export const refreshAccessToken = (): Promise<LoginResponse> => {
  return axios
    .post(
      `${EndPoints.auth.refreshAccessToken}`,
      {
        refreshToken,
      },
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((_) => {
      destroyUserCache();
      Navigate({ to: Paths.LoginPage });
    });
};
